import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import firebaseApp from "./Firecontact";

const firestore = firebaseApp.firestore();

const StickyVideo = () => {
  const location = useLocation();
  const hideOnPages = ['/ai-content-studio', '/QRCodeGenerator'];
  
  const [isVisible, setIsVisible] = useState(true);
  const [videoUrl, setVideoUrl] = useState(null);

  useEffect(() => {
    const unsubscribe = firestore
      .collection("cardVideos")
      .orderBy("date", "desc")
      .limit(1)
      .onSnapshot((snapshot) => {
        if (!snapshot.empty) {
          const latest = snapshot.docs[0].data();
          setVideoUrl(latest.url);
        }
      });

    return () => unsubscribe();
  }, []);

  if (!isVisible || !videoUrl || hideOnPages.includes(location.pathname)) return null;

  return (
    <div className="sticky-video-container">
      <Card className="video-card rounded-3">
        <div className="video-wrapper rounded-3">
          <iframe
            src={videoUrl}
            title="YouTube Shorts"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className="video-player rounded-3"
          />
        </div>

        <div
          className="video-close-icon"
          onClick={(e) => {
            e.stopPropagation();
            setIsVisible(false);
          }}
        >
          <i className="lni lni-cross-circle closeicon d-flex"></i>
        </div>
      </Card>
    </div>
  );
};

export default StickyVideo;
